import {s_char_matrices, s_char_matricespells} from "../../_signals/s_char";
import {v4} from "uuid/wrapper.mjs";
import React, {useEffect, useState} from "react";
import {ICharMatrice} from "../../_interfaces/ICharMatrice";
import {DialogTitle, ListSubheader} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {MatricesDelete, MatricesUpdate} from "../../_api/BEMatrices";
import {MatricespellsDelete} from "../../_api/BEMatricespells";
import {matrices} from "../../_helper/matrices";

interface IProp {
    open: string,
    isOpen: (open: '') => void
}

export default function MatriceEdit({open, isOpen}: IProp) {

    const mod_rank = [...Array(16).keys()]

    const availableMatrices = matrices

    const [matrice, setMatrice] = useState<ICharMatrice | null>(null)
    const [openDialog, setOpenDialog] = useState(false)

    useEffect(() => {
        if (open) {
            const matrice = s_char_matrices.value.find(m => m.id === open);
            if (matrice) {
                setMatrice(matrice)
                setOpenDialog(true)
            } else {
                setMatrice(null)
                setOpenDialog(false)
            }
        } else setMatrice(null)
    }, [open])

    const save = () => {
        if (matrice) {
            let matrices = s_char_matrices.value;
            matrices.map(m => {
                if (m.id === matrice.id) {
                    MatricesUpdate(matrice)
                    return matrice
                }
                return m
            })
            s_char_matrices.value = matrices;
        }
    }

    const remove = () => {
        if (matrice) {
            let m = s_char_matrices.value;
            m = m.filter(m => m.id !== matrice.id)
            MatricesDelete(matrice)

            s_char_matrices.value = m
            let mss = s_char_matricespells.value;
            const remove = mss.filter(m => m.id === matrice.id)
            mss = mss.filter(m => m.id !== matrice.id)
            s_char_matricespells.value = mss
            remove.forEach(ms => {
                MatricespellsDelete(ms)
            })
            isOpen('')
        }
    }

    const cancel = () => {
        isOpen('')
    }

    const updateRank = (rank: number) => {
        if (matrice) setMatrice({...matrice, rank: rank})
    }

    const updateName = (name: string) => {
        const mat = matrices[name];
        if (matrice) setMatrice({
            ...matrice,
            name: name,
            can_hold_threads: mat.can_hold_thread,
            split: mat.split,
            splittable: mat.splittable,
            tot: mat.tot
        })
    }

    return <>
        {openDialog ? <Dialog open={openDialog}>
                <DialogTitle>{matrice?.name} Bearbeiten</DialogTitle>
                <DialogContent>
                    <Select value={matrice?.name}
                            onChange={(e) => updateName(e.target.value)}
                            variant="standard"
                            name={'name'}
                    >
                        {Object.keys(availableMatrices).map(talent => <MenuItem key={v4()} value={talent}>
                            {talent}
                        </MenuItem>)}
                    </Select>
                    <div>
                        <div>{matrice?.name}</div>
                        {matrice?.can_hold_threads ?
                            <div style={{fontSize: 'smaller', fontStyle: 'italic', paddingLeft: 8}}>Kann Faden
                                halten</div> : null}
                        {matrice?.splittable ?
                            <div style={{fontSize: 'smaller', fontStyle: 'italic', paddingLeft: 8}}>Spaltbar</div> : null}
                        {matrice?.tot ?
                            <div style={{
                                fontSize: 'smaller',
                                fontStyle: 'italic',
                                paddingLeft: 8
                            }}>Todesschwelle {matrice?.tot}</div> : null}
                    </div>
                    <Select key={v4()}
                            value={matrice?.rank ?? 0}
                            onChange={(e) => updateRank(e.target.value as number)}
                            name={'rank'}
                    >
                        <ListSubheader>Kreis</ListSubheader>
                        {mod_rank.map(
                            r => <MenuItem key={v4()} value={r}>{r}</MenuItem>
                        )}
                    </Select>
                </DialogContent>
                <DialogActions>
                    <Button className={'btn'} id="post" onClick={() => save()}><CheckIcon/></Button>
                    <Button className={'btn'} id="post" onClick={() => remove()}>
                        <DeleteOutlineIcon/>
                    </Button>
                    <Button className={'btn'} id="post" onClick={() => cancel()}><ClearIcon/></Button>
                </DialogActions>
            </Dialog>
            :
            null
        }
    </>
}